export const PEOPLE_DEPT_DATA = {
  health: {
    score: 78,
    trend: '+2',
    status: 'amber',
    summary: 'Team morale is stable. 2 critical hires in pipeline (Senior Dev, Product Designer). Engagement score steady at 8.1/10 but Engineering team flagged for burnout risk.',
  },

  agents: [
    {
      id: 'tali',
      name: 'Tali',
      role: 'People Intelligence AI',
      status: 'active',
      currentTask: 'Screening 12 Senior Developer candidates — shortlist ready by EOD',
      lastAction: 'Flagged Engineering team burnout risk based on overtime patterns',
      lastActionTime: '28 min ago',
    },
  ],

  alerts: [
    {
      id: 'ppa1',
      title: 'Engineering team burnout risk — 3 members averaging 52+ hrs/week',
      severity: 'high',
      agents: ['tali'],
      description: 'Three engineers have averaged 52+ hours/week for the past 4 weeks. Overtime correlates with the Acme Corp P1 and v3.2 release. Risk of attrition if sustained.',
      actions: [
        { agent: 'tali', label: 'Analyzed overtime patterns — spike started 4 weeks ago with v3.2 release', status: 'complete' },
        { agent: 'tali', label: 'Drafted workload redistribution plan with Engineering Lead', status: 'in-progress' },
        { agent: 'tali', label: 'Recommend 2 comp days for affected team members', status: 'recommended' },
      ],
    },
    {
      id: 'ppa2',
      title: 'Senior Developer role — 45 days open, pipeline thinning',
      severity: 'medium',
      agents: ['tali'],
      description: 'Critical hire has been open for 45 days. Initial pipeline of 28 candidates narrowed to 3 finalists. One dropped out last week citing compensation. Budget may need adjustment.',
      actions: [
        { agent: 'tali', label: 'Screened 12 new candidates from LinkedIn and referrals', status: 'in-progress' },
        { agent: 'tali', label: 'Benchmarked comp against market — we\'re 8% below median for this role', status: 'complete' },
        { agent: 'tali', label: 'Recommend increasing salary band by 10% to remain competitive', status: 'recommended' },
      ],
    },
    {
      id: 'ppa3',
      title: 'Q1 performance reviews — 4 overdue across Sales and Support',
      severity: 'medium',
      agents: ['tali'],
      description: 'Performance review cycle deadline passed 5 days ago. 4 reviews still outstanding: 2 in Sales (David\'s team), 2 in Support (Maya\'s team).',
      actions: [
        { agent: 'tali', label: 'Sent automated reminders to David and Maya with pre-filled templates', status: 'complete' },
        { agent: 'tali', label: 'Drafted review summaries from performance data for manager review', status: 'in-progress' },
      ],
    },
  ],

  decisions: [
    { id: 'ppd1', title: 'Approve salary band increase for Senior Developer role (+10%)', agent: 'tali', urgency: 'high', detail: 'Current band: $140-160K. Market median: $165K. Tali recommends adjusting to $150-175K. Cost impact: $15K/yr. Role has been open 45 days and we lost a finalist on comp.' },
    { id: 'ppd2', title: 'Approve 2 comp days for Engineering team (burnout mitigation)', agent: 'tali', urgency: 'medium', detail: '3 engineers at 52+ hrs/week for 4 weeks. 2 comp days per person (6 person-days total). Tali projects this reduces attrition risk from 35% to 12%.' },
    { id: 'ppd3', title: 'Sign off on Product Designer job posting', agent: 'tali', urgency: 'medium', detail: 'Priya requested a Product Designer to support the marketing site redesign. Tali drafted the JD and comp range ($110-130K). Posting ready for your approval.' },
  ],

  openRoles: [
    { id: 'pr1', title: 'Senior Developer', department: 'Engineering', daysOpen: 45, candidates: 3, status: 'interviewing', urgency: 'critical' },
    { id: 'pr2', title: 'Product Designer', department: 'Marketing', daysOpen: 0, candidates: 0, status: 'pending approval', urgency: 'medium' },
    { id: 'pr3', title: 'Sales Development Rep', department: 'Sales', daysOpen: 12, candidates: 8, status: 'screening', urgency: 'normal' },
    { id: 'pr4', title: 'Customer Success Manager', department: 'Support', daysOpen: 22, candidates: 5, status: 'interviewing', urgency: 'normal' },
  ],

  metrics: [
    { label: 'Team Size', value: '32', trend: '+2', trendUp: true },
    { label: 'Engagement', value: '8.1/10', trend: '+0.2', trendUp: true },
    { label: 'Open Roles', value: '4', trend: '+1', trendUp: false },
    { label: 'Avg. Tenure', value: '2.4 yrs', trend: '+0.3', trendUp: true },
    { label: 'Attrition Risk', value: '3', trend: '+1', trendUp: false, alert: true },
    { label: 'eNPS', value: '68', trend: '+4', trendUp: true },
  ],

  recentActivity: [
    { id: 'pra1', agent: 'tali', action: 'flagged Engineering team burnout risk — 3 members at 52+ hrs/week', time: '28 min ago', type: 'alert' },
    { id: 'pra2', agent: 'tali', action: 'screened 12 new candidates for Senior Developer role', time: '1 hr ago', type: 'action' },
    { id: 'pra3', agent: 'tali', action: 'sent performance review reminders to David and Maya', time: '2 hrs ago', type: 'action' },
    { id: 'pra4', agent: 'tali', action: 'benchmarked Senior Developer comp — we\'re 8% below market median', time: '3 hrs ago', type: 'insight' },
    { id: 'pra5', agent: 'tali', action: 'drafted Product Designer JD and comp range ($110-130K)', time: '4 hrs ago', type: 'action' },
    { id: 'pra6', agent: 'tali', action: 'analyzed Q4 engagement survey results by department', time: '5 hrs ago', type: 'insight' },
    { id: 'pra7', agent: 'tali', action: 'identified 2 high-performers at flight risk based on sentiment signals', time: 'Yesterday', type: 'alert' },
    { id: 'pra8', agent: 'tali', action: 'completed monthly headcount forecast for Q2 planning', time: 'Yesterday', type: 'action' },
  ],
};

export const PEOPLE_DEPT_CHAT_RESPONSES = {
  deepDive: {
    text: "Here's my strategic analysis of People.\n\nOverall health is 78 — engagement is steady but two areas need attention: Engineering burnout and a stalling critical hire.",
    actions: [
      { agent: 'tali', label: 'Engineering burnout — 3 members at 52+ hrs/week for 4 weeks. Comp days + workload redistribution recommended', status: 'pending-approval' },
      { agent: 'tali', label: 'Senior Developer role open 45 days — comp band 8% below market. Recommend 10% increase to close', status: 'pending-approval' },
      { agent: 'tali', label: '4 overdue performance reviews (Sales + Support) — auto-reminders sent with pre-filled templates', status: 'in-progress' },
      { agent: 'tali', label: 'Product Designer JD drafted per Priya\'s request — ready for sign-off', status: 'pending-approval' },
    ],
    timeline: 'If the comp band adjustment is approved today, Tali can re-engage the dropped finalist and accelerate the pipeline. Burnout risk can be mitigated within the week with comp days.',
  },
  general: {
    text: "I'm monitoring People operations. Here's the current state:\n\nTeam morale is stable at 8.1/10 engagement, but the Engineering team needs attention — overtime patterns suggest burnout risk for 3 members.\n\nOn hiring, the Senior Developer role has been open 45 days and we're losing candidates on compensation. I've benchmarked the market and have a recommendation ready.\n\nTwo items need your decision: the salary band adjustment and the comp days for the Engineering team.\n\nWant me to dig into any of these?",
  },
};
